import { Box,Fab} from "@mui/material"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { Add } from "@mui/icons-material";
import { useContext } from "react"
import { ToolContext } from "../../../../../../core/context/ToolContext";

export const Top = () => {
    const { install_state } = useContext(ToolContext)
    const nav = useHistory()
    const handleTeam = () => {
        nav.push('/speakout/team/create')
    }
    
    return (
        <Box> 
            <Box position="fixed" display="flex" flexDirection="column" alignItems="flex-end" right={25} zIndex={1101}  sx={{transition: 'bottom 0.3s ease 0s'}} bottom={(install_state.prompt.data !== null ? 139 :75) } >
                <Fab  sx={{ bgcolor: '#107038ff', height: '48px', width: '48px', boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.04),0px 8px 16px rgba(0, 0, 0, 0.08)' ,}} onClick={handleTeam}>
                    <Add sx={{color: '#FFFFFF'}}/>
                </Fab>
            </Box>  
        </Box>

    )
}